module.exports = __webpack_public_path__ + "static/media/club-tarjeta-bloque.a38d1ca5.png";